import Marquee from "react-fast-marquee";

const WORDS = [
  "Mutual Funds",
  "Systematic Investment Plans",
  "Specialized Investment Funds",
  "Goal Planning",
  "Life Insurance",
  "Health Insurance",
  "Children's Future",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-white/10 py-6 bg-[#0A0F1C]"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-3xl md:text-5xl text-white/85 px-8">
            {w}
          </span>
          <span className="text-gold text-2xl">&#10022;</span>
        </span>
      ))}
    </Marquee>
  </div>
);
